import { BrowserCacheLocation, InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalGuard,
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
  MsalModule,
  MsalService,
} from '@azure/msal-angular';
import { NgModule } from '@angular/core';

import { AuthContext } from '../auth.helpers';
import { ISS_LOGOUT_URI, ISS_REDIRECT_URI, WO_PROTECTED_RESOURCES } from '../auth.config';

import { environment } from '@wo-environments';

const scopes = [ 'openid', 'profile', 'offline_access', environment.oauth2.scope ];

function MSALInstanceFactory(redirectUri: string, logoutUri: string): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.oauth2.clientId,
      authority: environment.oauth2.authority,
      knownAuthorities: environment.oauth2.knownAuthorities,
      redirectUri,
      protocolMode: environment.oauth2.protocol,
      postLogoutRedirectUri: logoutUri,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
  });
}

function MSALGuardConfigFactory(redirectUri: string): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: scopes,
      prompt: 'select_account',
      loginHint: AuthContext.getEmail(),
      redirectUri,
    },
  };
}

function MSALInterceptorConfigFactory(protectedResources: readonly string[], redirectUri: string): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map(protectedResources.map(r => ([ r, scopes ]))),
    authRequest: {
      prompt: 'select_account',
      loginHint: AuthContext.getEmail(),
      redirectUri,
    },
  };
}

@NgModule({
  imports: [
    MsalModule,
  ],
  providers: [
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
      deps: [ ISS_REDIRECT_URI, ISS_LOGOUT_URI ],
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
      deps: [ ISS_REDIRECT_URI ],
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
      deps: [ WO_PROTECTED_RESOURCES, ISS_REDIRECT_URI ],
    },
    MsalService,
    MsalGuard,
  ],
})
export class MsalAuthModule {}
